export const baseUrl = "https://hccapi2.mobifone5.vn/hcchphtanhung"
export default {
    baseUrl
}
